interface BladderIrrigationProps {
  appearanceOfLiquidDescription?: string;
  descriptionTopography?: string;
  irrigationSequence: number;
  itemQuantity?: number;
  itemSequence?: string;
  prescriptionValidate?: string;
  side?: string;
}

enum BladderIrrigationStatus {
  ADMINISTERED = 'ADMINISTERED',
  PENDING = 'PENDING',
  STARTED = 'STARTED',
}

enum BladderIrriationItemStatus {
  PENDING = 'P',
  STARTED = 'I',
  FINISHED = 'F',
}

interface RegisterBladderIrrigationResponse {
  irrigationSequence?: number;
}

interface RegisterBladderIrrigationRequest {
  aspectSequence?: number
  currentTime?: string;
  drainedQuantity?: number;
  encounterId?: number;
  infusionQuantity?: number;
  irrigationOrWashing?: string;
  irrigationSequence?: number;
  newIrrigation?: string;
  observation?: string;
  registerDate?: string;
  scheduleTimeSequence?: number;
  userName?: string;
}

interface AppearanceOfLiquidType {
  appearanceOfLiquidCode?: number;
  appearanceOfLiquidDescription?: string;
}

enum IrrigationOrWashingType {
  IRRIGATION = 'I',
  WASHING = 'L'
}

enum Keys {
  KEY1 = '1',
  KEY2 = '2'
}

export {
  BladderIrrigationProps,
  BladderIrrigationStatus,
  BladderIrriationItemStatus,
  RegisterBladderIrrigationRequest,
  RegisterBladderIrrigationResponse,
  AppearanceOfLiquidType,
  IrrigationOrWashingType,
  Keys,
}